var appwaiver = angular.module('appwaiver', ['ngSanitize', 'pascalprecht.translate'])
.config(['$translateProvider',
	function ($translateProvider) {

	    $translateProvider.translations('en', dictEN)
			.translations('bg', dictBG)
            .translations('es', dictES)
            .translations('pt', dictPT)
            .translations('esc', dictESC)
            .translations('esm', dictESM)
            .translations('it', dictIT)
            .translations('ro', dictRO)
            .translations('lt', dictLT)
            .translations('id', dictID)
            .translations('de', dictDE);

        if (curLang) {
            curLang = getLangAbr(curLang)
            $translateProvider.preferredLanguage(curLang);
        }else if ( gym[0].Culture == 'bg-BG') {
            $translateProvider.preferredLanguage('bg');
        }else if(gym[0].Culture.includes('-ES')){
            if (gym[0].Culture == 'ca-ES' || gym[0].Culture == 'ca-ES-valencia') {
                $translateProvider.preferredLanguage('esc');
            }else{
                $translateProvider.preferredLanguage('es');
            }
        }else if(gym[0].Culture == 'es-MX'){
            $translateProvider.preferredLanguage('esm');
        }else if(gym[0].Culture.includes('pt')){
            $translateProvider.preferredLanguage('pt');
        }else if(gym[0].Culture.includes('it')){
            $translateProvider.preferredLanguage('it');
        }else if(gym[0].Culture.includes('ro')){
            $translateProvider.preferredLanguage('ro');
        }else if(gym[0].Culture.includes('lt')){
            $translateProvider.preferredLanguage('lt');
        }else if(gym[0].Culture.includes('id')){
            $translateProvider.preferredLanguage('id');
        }else if(gym[0].Culture.includes('de')){
            $translateProvider.preferredLanguage('de');
        }else{
            
            $translateProvider.preferredLanguage('en');
        }

        function getLangAbr(lang){
            let newLang;
            if (lang == 'English') {
                newLang = 'en';
            }else if (lang == 'Bulgarian'){
                newLang = 'bg';
            }else if (lang == 'Spanish'){
                newLang = 'es';
            }else if (lang == 'Portuguese'){
                newLang = 'pt';
            }else if(lang == 'Catalan'){
                newLang = 'esc';
            }else if(lang == 'Mexican'){
                newLang = 'esm';
            }else if(lang == 'Italian'){
                newLang = 'it';
            }else if(lang == 'Romanian'){
                newLang = 'ro';
            }else if(lang == 'Lithuanian'){
                newLang = 'lt';
            }else if(lang == 'Indonesian'){
                newLang = 'id';
            }else if(lang == 'German'){
                newLang = 'de';
            }else{
                newLang = 'en';
            }

            return newLang;
        }

}]);